export enum PaymentRequestOperationTypeEnum {
  PaymentToTheSupplier = 0,
  DisbursmentOfMoney = 1,
  CustomsFee = 2,
  PaymentToEmployee = 3,
  PaymentOnCreditsAndLoansReceived = 4,
  TransferToDeposits = 5,
  TransferMoneyBetweenTheOrganizationAndTheBranch = 6,
  IssuanceOfALoanToACounterparty = 7,
  IssuingALoanToAnEmployee = 8,
  CurrencyConversion = 9,
  RefundOfPaymentToTheClient = 10,
  InternalTransfer = 11,
  OtherExpenses = 12,
}
